/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Select_CategoriesInputs */

const en_btn_select_categories = /** @type {(inputs: Btn_Select_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Categories`)
};

/**
* | output |
* | --- |
* | "Select Categories" |
*
* @param {Btn_Select_CategoriesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const btn_select_categories = /** @type {((inputs?: Btn_Select_CategoriesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Select_CategoriesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_select_categories(inputs)
});